export const EDITION = {
  NONE: 'none',
  PRINT: 'print',
  DIGITAL: 'digital'
};

export const MAX_SECTION = 100;
